export default function CtaBanner() {
  return (
    <section id="download" className="mx-auto max-w-[1200px] px-4 pb-4 pt-2 md:px-6">
      <div className="relative overflow-hidden rounded-3xl bg-foreground-950 px-6 py-12 text-center md:px-12 md:py-16">
        <div className="pointer-events-none absolute -left-16 -top-20 h-64 w-64 rounded-full bg-primary-500/30 blur-3xl"></div>
        <div className="pointer-events-none absolute -bottom-24 -right-10 h-72 w-72 rounded-full bg-accent-500/25 blur-3xl"></div>

        <div className="relative mx-auto max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1.5 text-xs font-medium text-background-100">
            <i className="ri-bell-line"></i>
            告别错过热搜的每一分钟
          </span>
          <h3 className="mt-5 font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
            让「吃瓜王提醒」帮你盯着瓜田
          </h3>
          <p className="mt-4 text-sm leading-6 text-background-200 md:text-base">
            热点一冒头就第一时间推给你，还支持按分区订阅、只看想看的瓜。下载吃瓜王，
            榜单一手拿。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#top"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-accent-500 px-6 py-3.5 text-sm font-semibold text-foreground-950 whitespace-nowrap transition-colors hover:bg-accent-400 sm:w-auto"
            >
              <i className="ri-download-2-line text-lg"></i>
              下载吃瓜王 App
            </a>
            <a
              href="#rank"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-background-50/30 px-6 py-3.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-background-50/10 sm:w-auto"
            >
              <i className="ri-mail-send-line"></i>
              订阅每日瓜报
            </a>
          </div>

          <p className="mt-5 text-xs text-background-300">支持 iOS / Android · 微信群准时推送 · 随时退订</p>
        </div>
      </div>
    </section>
  );
}